import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Box
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';

const ForgotPasswordModal = ({ open, onClose }) => {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    const result = await resetPassword(email);
    if (result.success) {
      setSuccess(true);
      setEmail('');
      toast.success('Se existir conta, enviaremos uma nova senha por email.');
    } else {
      setError(result.error);
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  const handleClose = () => {
    setEmail('');
    setError('');
    setSuccess(false);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          background: 'rgba(10, 10, 10, 0.9)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(157, 0, 255, 0.2)',
          color: 'white'
        }
      }}
    >
      <DialogTitle>
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Orbitron',
            fontWeight: 700,
            background: 'linear-gradient(45deg, #8B5CF6, #06B6D4)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textAlign: 'center'
          }}
        >
          Esqueci minha senha
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        {success ? (
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Alert severity="success" sx={{ mb: 2 }}>
              Nova senha enviada com sucesso!
            </Alert>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Verifique seu email para receber a nova senha.
            </Typography>
          </Box>
        ) : (
          <Box component="form" onSubmit={handleSubmit}>
            <Typography variant="body2" sx={{ mb: 3, opacity: 0.8 }}>
              Digite seu email para receber uma nova senha:
            </Typography>
            
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={{ mb: 2 }}
            />
          </Box>
        )}
      </DialogContent>
      
      <DialogActions sx={{ p: 3 }}>
        {success ? (
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              background: 'linear-gradient(45deg, #8B5CF6, #06B6D4)',
              '&:hover': {
                background: 'linear-gradient(45deg, #7C3AED, #0891B2)',
              }
            }}
          >
            Fechar
          </Button>
        ) : (
          <>
            <Button onClick={handleClose} sx={{ color: 'rgba(255,255,255,0.7)' }}>
              Cancelar
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={loading || !email}
              sx={{
                background: 'linear-gradient(45deg, #8B5CF6, #06B6D4)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #7C3AED, #0891B2)',
                },
                '&:disabled': {
                  bgcolor: 'rgba(157, 0, 255, 0.3)',
                }
              }}
            >
              {loading ? <CircularProgress size={20} /> : 'Enviar'}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ForgotPasswordModal;
